import { ChainName } from '../interface';

export const getChainId = (name: string): number => {
  if (name === 'Polygon') {
    return 137;
  }
  if (name === 'Mumbai') {
    return 80001;
  }
  if (name === 'Ethereum') {
    return 1;
  }
  if (name === 'Goerli') {
    return 5;
  }
  if (name === 'Sepolia') {
    return 11155111;
  }

  return 0;
};

export const getNetworkName = (chainId: number): string => {
  if (chainId === 137) {
    return 'Polygon';
  }
  if (chainId === 80001) {
    return 'Mumbai';
  }
  if (chainId === 1) {
    return 'Ethereum';
  }
  if (chainId === 5) {
    return 'Goerli';
  }
  if (chainId === 11155111) {
    return 'Sepolia';
  }

  return 'Ethereum';
};

export const getActiveChainId = (chainName: ChainName) => {
  switch (chainName) {
    case 'sepolia':
      return 11155111;
    case 'base-sepolia-testnet':
      return 84532;
    case 'base':
      return 8453;
    case 'ethereum':
      return 1;
    case 'goerli':
      return 5;
    case 'mumbai':
      return 80001;
    case 'polygon':
      return 137;
    default:
      return 11155111;
  }
};
